import { JSX, SVGProps } from 'react';

export const Nuxt = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 298" {...props}>
    <g fill="none">
      <path
        fill="#00C58E"
        d="m227.921 82.074-13.689 23.704-46.815-81.087-143.713 248.89h97.303c0 13.09 10.613 23.703 23.704 23.703H23.704A23.704 23.704 0 0 1 3.18 261.728L146.893 12.84a23.704 23.704 0 0 1 41.057 0z"
      />
      <path
        fill="#2F495E"
        d="m331.664 261.728-90.054-155.95-13.689-23.704-13.689 23.704-90.044 155.95a23.704 23.704 0 0 0 20.523 35.556h166.4a23.704 23.704 0 0 0 20.533-35.556zM144.711 273.58l83.21-144.099 83.19 144.1z"
      />
      <path
        fill="#108775"
        d="M396.05 285.432a23.7 23.7 0 0 1-20.524 11.852H311.11c13.091 0 23.704-10.613 23.704-23.704h40.662L260.099 73.748l-18.49 32.03-13.688-23.704 11.654-20.178a23.704 23.704 0 0 1 41.057 0L396.05 261.728a23.7 23.7 0 0 1 0 23.704"
      />
    </g>
  </svg>
);
